import { useState, useCallback } from 'react'
import AudienceDetailContent from '@/pages/AudiencesPage/components/AudienceDetailContent'
import { ComposeModal } from '@/pages/ConversationsPage/ComposeModal/ComposeModal'
import { useParams } from '@/routing/navigation'
import type { AudienceSummary } from '@/lib/api'

interface InitialTwin {
  personaId: string
  populationId: string
  personaName?: string
  imageUrl?: string
}

export default function AudienceDetailsPage() {
  const { id = '' } = useParams<{ id: string }>()

  const [composeOpen, setComposeOpen] = useState(false)
  const [composeInitialTwin, setComposeInitialTwin] = useState<InitialTwin | null>(null)
  const [composeAudienceId, setComposeAudienceId] = useState<string | null>(null)
  const [composeAudienceSnapshot, setComposeAudienceSnapshot] = useState<AudienceSummary | null>(null)

  const handleOpenChat = useCallback((payload: { audienceId: string; audience?: AudienceSummary | null }) => {
    setComposeAudienceId(payload.audienceId)
    setComposeAudienceSnapshot(payload.audience ?? null)
    setComposeInitialTwin(null)
    setComposeOpen(true)
  }, [])

  const handleOpenChatWithTwin = useCallback((twin: InitialTwin) => {
    setComposeInitialTwin(twin)
    setComposeAudienceId(null)
    setComposeAudienceSnapshot(null)
    setComposeOpen(true)
  }, [])

  const handleComposeOpenChange = useCallback((open: boolean) => {
    setComposeOpen(open)
    if (!open) {
      setComposeInitialTwin(null)
      setComposeAudienceId(null)
      setComposeAudienceSnapshot(null)
    }
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <AudienceDetailContent
        audienceId={id}
        variant="page"
        onOpenChat={handleOpenChat}
        onOpenChatWithTwin={handleOpenChatWithTwin}
      />
      <ComposeModal
        open={composeOpen}
        onOpenChange={handleComposeOpenChange}
        initialTwin={composeInitialTwin}
        initialAudienceId={composeAudienceId}
        initialAudienceSnapshot={composeAudienceSnapshot}
      />
    </div>
  )
}
